import { checkDeviceNow, requestDeviceAgain } from '../../device/gate'
import { Icon } from '../../components/Icon'
import { useConnection } from '../../state/connection'
import { useDeviceGate } from '../../state/device'
import { DeviceGateLayout } from './DeviceGateLayout'

const copy = {
  denied: {
    title: 'This device was not approved',
    body: 'A system administrator declined the request to use BOSS Chat on this device. If you think this is a mistake, contact IT and quote this code:',
  },
  revoked: {
    title: 'This device has been removed',
    body: 'This device can no longer be used for BOSS Chat. If you need access again, contact IT and quote this code:',
  },
  expired: {
    title: 'This request expired',
    body: 'Nobody approved this device in time. Request approval again, then ask a system administrator to approve this code:',
  },
} as const

export function DeviceBlockedScreen() {
  const status = useDeviceGate((s) => s.device.status)
  const busy = useDeviceGate((s) => s.checking || s.attesting)
  const online = useConnection((s) => s.online)
  const kind = status === 'denied' || status === 'revoked' || status === 'expired' ? status : 'denied'
  const text = copy[kind]

  return (
    <DeviceGateLayout
      icon="alert"
      title={text.title}
      tone="blocked"
      actions={
        kind === 'expired' ? (
          <button type="button" className="button primary" disabled={busy || !online} onClick={() => void requestDeviceAgain()}>
            <Icon name="refresh" />
            {busy ? 'Requesting…' : 'Request again'}
          </button>
        ) : (
          <button type="button" className="button" disabled={busy || !online} onClick={() => void checkDeviceNow()}>
            <Icon name="refresh" />
            {busy ? 'Checking…' : 'Check again'}
          </button>
        )
      }
    >
      <p>{text.body}</p>
    </DeviceGateLayout>
  )
}
